import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AFEntity, AFRegistrationDomain, SignInModel } from '../model/af.model';
import { AuthService } from '../service/auth.service';
import { EventService } from '../service/event.service';
import { ChangeLoginEvent, DismissSnackBarEvent, ShowLoaderEvent, SkipToMainContentEvent } from "../service/events";
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})

export class LoginComponent implements OnInit {

  user: AFEntity;
  vendorUser: AFRegistrationDomain;
  private readonly eventBus: EventService;
  private readonly login_registration: number = 1;
  private readonly login_aa: number = 2;
  private readonly login_dispute: number = 3;
  login_vendor: number = 4;
  loginType: number;

  form = this.fb.group({
    password: ['', Validators.required]
  });

  constructor(private readonly userService: AuthService,
    private readonly fb: UntypedFormBuilder,
    private readonly router: Router,
    eventBus: EventService
  ) {
    this.eventBus = eventBus;
    this.initiateLogin();
  }

  ngOnInit() {
    this.eventBus.on(
      SkipToMainContentEvent,
      (event): void => {
        if (event.payload.text && event.payload.text == "/login") {
          let mainContentElement = document.querySelector("#main-content"); //check if main-content id exists on page
          if (mainContentElement) {
            mainContentElement.scrollIntoView(true);
          }
        }
      }
    );

    this.eventBus.emit(new DismissSnackBarEvent({}));
  }

  onFocusOutMainContent(event) {
    this.eventBus.emit(new SkipToMainContentEvent({ text: "FocusOff" }));
  }

  initiateLogin(): void {

    this.loginType = Number(localStorage.getItem('loginType'));

    if (this.loginType !== 4) {
      this.user = this.userService.getUser();
    } else {
      this.vendorUser = this.userService.getVendorUser();
    }
  }

  get password() { return this.form.get('password') };

  onSubmit() {
    const loginType = Number(localStorage.getItem('loginType'));
    if (this.login_registration == loginType) {
      let signInModel = new SignInModel();
      signInModel.verifyId = this.userService.getVerifyId();
      signInModel.username = this.user.email;
      signInModel.password = this.form.get("password").value;

      this.userService.signIn(signInModel).subscribe({
        next: () => {
          this.getLoginApplicantDetails();
          this.eventBus.emit(new ChangeLoginEvent({ afEntity: this.user }));
         

        },
        error: (error: any) => console.log(error)
      });
    } else if (this.login_aa == loginType) {
      this.router.navigate(['latestAAGenLetter']);
    } else if (this.login_dispute == loginType) {
      let signInModel = new SignInModel();
      signInModel.verifyId = this.userService.getVerifyId();
      signInModel.username = this.user.email;
      signInModel.password = this.form.get("password").value;
      this.userService.signIn(signInModel).subscribe({
        next: () => {
          this.router.navigate(['disputeQuestionnaire']);
        },
        error: (error: any) => console.log(error)
      });
    } else if (this.login_vendor == loginType) {
      let signInModel = new SignInModel();
      signInModel.verifyId = this.userService.getVerifyId();
      signInModel.username = this.vendorUser.username;
      signInModel.password = this.form.get("password").value;
      signInModel.vendorSign = true;
      this.userService.signIn(signInModel).subscribe({
        next: () => {
          this.router.navigate(['vendorDashboard']);

        },
        error: (error: any) => console.log(error)
      });
    }
  }
  getApplicantDetails() {
     this.userService.getApplicantDetails(false,true).subscribe({
          next: (data: AFEntity) => {
            sessionStorage.setItem(environment.user_object, JSON.stringify(data));
            if (data.skinnyFlag === 1) {
              localStorage.setItem('skinnyForm', '1');
            } else{
              localStorage.setItem('skinnyForm', '0');
            }
    
            this.eventBus.emit(new ShowLoaderEvent({ show: true }));
            if (this.userService.getBookmarkUrl() != null) {
              let navlink = this.userService.getNavLinks().find(e => e.routerLink === this.userService.getBookmarkUrl());
              sessionStorage.setItem('maxNavigation', navlink.id.toString());
              this.router.navigate([this.userService.getBookmarkUrl()]);
            } else {
              this.router.navigate(['introduction']);
            }
          },
          error: (error: Error) => {
            console.log("Error loading applicant: ", error);
            this.router.navigate(['unauthorized']);
            this.eventBus.emit(new ShowLoaderEvent({ show: true }));
          }
        });
  }

  getLoginApplicantDetails() {
    this.userService.getLoginApplicantDetails(false,true).subscribe({
         next: (data: AFEntity) => {
           sessionStorage.setItem(environment.user_object, JSON.stringify(data));
           if (data.skinnyFlag === 1) {
             localStorage.setItem('skinnyForm', '1');
           } else{
             localStorage.setItem('skinnyForm', '0');
           }
   
           this.eventBus.emit(new ShowLoaderEvent({ show: true }));
           if (this.userService.getBookmarkUrl() != null) {
             let navlink = this.userService.getNavLinks().find(e => e.routerLink === this.userService.getBookmarkUrl());
             sessionStorage.setItem('maxNavigation', navlink.id.toString());
             this.router.navigate([this.userService.getBookmarkUrl()]);
           } else {
             this.router.navigate(['introduction']);
           }
         },
         error: (error: Error) => {
           console.log("Error loading applicant: ", error);
           this.router.navigate(['unauthorized']);
           this.eventBus.emit(new ShowLoaderEvent({ show: true }));
         }
       });
 }
}
